export { default as VictoryGroup } from "./victory-group";


//////////////////
// WEBPACK FOOTER
// ./~/victory-group/es/index.js
// module id = ./node_modules/victory-group/es/index.js
// module chunks = 1